import { buttonClassName } from '@emailforge/ui';
import { Link } from 'react-router-dom';

export function ExportPackLanding() {
  return (
    <div style={{ maxWidth: 960, margin: '80px auto', padding: '0 24px' }}>
      <div
        className="mono"
        style={{ fontSize: 11, color: 'var(--flame-2)', letterSpacing: 0.08, textTransform: 'uppercase' }}
      >
        One-time purchase · €29
      </div>
      <h1
        className="display"
        style={{ fontSize: 64, margin: '20px 0 16px', letterSpacing: -0.02, lineHeight: 1.04 }}
      >
        Export Pack — <i style={{ color: 'var(--flame)' }}>your templates, forever</i>
      </h1>
      <p style={{ fontSize: 18, color: 'var(--ink-2)', lineHeight: 1.5, maxWidth: 720 }}>
        Buy once, own forever. Export any template to <code className="mono">.tsx</code> + HTML inline. No lock-in. No
        subscription. Use in any React Email project.
      </p>

      <div style={{ display: 'flex', gap: 12, marginTop: 28 }}>
        <Link to="/checkout/export-pack" className={buttonClassName({ variant: 'flame' })}>
          Buy for €29
        </Link>
        <Link to="/pricing" className={buttonClassName()}>
          See all plans
        </Link>
      </div>

      <div
        className="mf-card"
        style={{ marginTop: 60, padding: 32, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}
      >
        {[
          { title: 'Export to .tsx', body: 'Full React Email source code. Customize however you want.' },
          { title: 'HTML inline', body: 'Pre-compiled, cross-client-tested HTML. Drop into your ESP.' },
          { title: 'No lock-in', body: 'Your templates live in your repo. Cancel anytime without losing anything.' },
        ].map((f) => (
          <div key={f.title}>
            <div style={{ fontWeight: 550, fontSize: 14, marginBottom: 6 }}>{f.title}</div>
            <div style={{ fontSize: 13, color: 'var(--ink-2)', lineHeight: 1.55 }}>{f.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
